"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classRegexCache = {};
function classRegex(className) {
    if (!classRegexCache[className]) {
        classRegexCache[className] = new RegExp('(\\s|^)' + className + '(\\s|$)');
    }
    return classRegexCache[className];
}
exports.default = classRegex;
